import { render, staticRenderFns } from "./SalaryCalculator.vue?vue&type=template&id=5f348f79&scoped=true&"
import script from "./SalaryCalculator.vue?vue&type=script&lang=js&"
export * from "./SalaryCalculator.vue?vue&type=script&lang=js&"
import style0 from "./SalaryCalculator.vue?vue&type=style&index=0&id=5f348f79&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f348f79",
  null
  
)

export default component.exports